import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LockerNumberService {
  private api = inject(ApiService);

  create(json: any) { return this.api.post('/lockerNumber/create', json); }
  exists(id: number, lockerNumber: number | string) {
    return this.api.get(`/lockerNumber/exists/${id}/${lockerNumber}`);
  }
  inUse(studioId: number, start: number, end: number) {
    return this.api.get(`/lockerNumber/in_use/${studioId}/${start}/${end}`);
  }
  async updateMemberId(json: any): Promise<any> {
    const response: any = await firstValueFrom(this.api.postRaw('/lockerNumber/update', json));
    if (response?.success !== true) throw new Error('ロッカー番号の更新を確認できませんでした');
    return response.result;
  }
  remove(json: any) { return this.api.post('/lockerNumber/remove', json); }
}
